import React, { useState } from 'react';
import {
  PreviewMainPage,
  WelcomeScreen,
  ViewAssessment,
} from '@premkumarmph/assessment-library';
import { useMutation, useLazyQuery } from '@apollo/client';
import { UPDATE_ASSESSMENT_STATUS } from '../services/Assessment/AssessmentService';
import { useSnackbar } from 'notistack';
import './AssessmentSubmission.css';

const AssessmentSubmission = ({
  setPreviewToggle,
  selectedAssessment,
  refetchTableData,
  setRefetchTableData,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [displayWelcomeScreen, setDisplayWelcomeScreen] = useState(
    selectedAssessment?.status?.toLowerCase() === 'pending' ||
      selectedAssessment?.status?.toLowerCase() === 'draft'
  );
  const [viewDetailsToggle, setViewDetailsToggle] = useState(false);
  const [updateStatus, setUpdateStatus] = useState('');
  const [updateAssessmentStatus, { data }] = useMutation(
    UPDATE_ASSESSMENT_STATUS,
    {
      onCompleted: res => {
        setDisplayWelcomeScreen(false);
      },
      onError: err => {
        enqueueSnackbar('Something went wrong', {
          variant: 'error',
        });
      },
    }
  );

  const updateStatusApi = async status => {
    const res = await updateAssessmentStatus({
      variables: {
        assessmentRequest: {
          assessmentInstanceId: selectedAssessment.id,
          status: status ?? 'in-progress',
        },
      },
    });
    if (res?.data?.updateAssessmentStatus) {
      setUpdateStatus(res?.data?.updateAssessmentStatus?.statusMessage);
    }
  };

  const handleStartAssessment = async status => {
    setDisplayWelcomeScreen(false)
    // if (status === 'in-progress') {
      // setPreviewToggle(false);
    // }
    // if (!updateStatus?.includes('complete')) {
    //   updateStatusApi(status);
    // }
  };

  const getStatusColor = () => {
    return '#148e3c';
  };

  const handleViewDetailsModal = () => {
    setViewDetailsToggle(true);
  };

  const handleSaveAndExit = async () => {
    setPreviewToggle(false);
    setRefetchTableData(prev => !prev);
  };

  const handleViewClose = () => {
    setRefetchTableData(prev => !prev);
    setPreviewToggle(false);
  };

  return (
    <>
      {displayWelcomeScreen ? (
        <WelcomeScreen
          logo={selectedAssessment.orgImageURL}
          handleExit={() => setPreviewToggle(false)}
          title={selectedAssessment.assessmentName}
          styles={{
            title: {
              fontWeight: 600,
              fontSize: '24px',
            },
          }}
          handleStartAssessment={handleStartAssessment}
        />
      ) : selectedAssessment?.status?.toLowerCase() === 'completed' ||
        viewDetailsToggle ? (
        <ViewAssessment
          assessmentStatus={'Completed'}
          dateHeader={'Completed on'}
          assessmentName={selectedAssessment?.assessmentName}
          logoURL={selectedAssessment?.orgImageURL}
          getStatusColor={getStatusColor}
          handleClose={handleViewClose}
          assessmentMeta={selectedAssessment}
        />
      ) : (
        <PreviewMainPage
          assessmentMeta={selectedAssessment}
          submitAssessmentFlag={true}
          handleViewDetailsModal={handleViewDetailsModal}
          handleSaveAndExit={handleSaveAndExit}
          fromENT={true}
          lastAnsweredIndex={-1}
          updateStatusApi={updateStatusApi}
        />
      )}
    </>
  );
};

export default AssessmentSubmission;
